import { useState } from "react"
import { map, size, pickBy, isFunction } from "lodash"
import { Popover, Paper, List, ListItem, ListItemText } from "@mui/material"
import { ArrowDropDown } from "@mui/icons-material"
import PropTypes from "prop-types"
import OPTooltip from "components/material/tooltip"
import classNames from "classnames"

export default function AggregationTableDropdown({ parentLevelOptions, dropdownTableTitle, label, onItemClick, selectedItemId }) {
  const [popperAnchor, setPopperAnchor] = useState(null)

  const handleClick = (itemId, replaceLastSelectedItem = false) => {
    setPopperAnchor(null)
    onItemClick(itemId, replaceLastSelectedItem)
  }

  const items = pickBy(parentLevelOptions, ({ children }) => children)

  return (<span className="table-dropdown">
    {size(items) === 1
      ? label
      : <>
        <OPTooltip enterDelay={300} title={label}>
          <a onClick={(event) => setPopperAnchor(event.target)}>{label} <ArrowDropDown /></a>
        </OPTooltip>
        <Popover
          disablePortal={false}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          classes={{
            root: "table-dropdown-popover",
          }}
          open={!!popperAnchor}
          onClose={() => setPopperAnchor(null)}
          anchorEl={popperAnchor}
          transitionDuration={0}
        >
          <Paper className="table-dropdown-paper" elevation={3}>
            <div className="dropdown-header">
              {dropdownTableTitle}
            </div>
            <List className="table-dropdown-list" disablePadding>
              {map(items, ({ label, formatter }, itemId) => (
                <ListItem
                  key={`${itemId}-item`}
                  className={classNames("table-dropdown-item", { selected: selectedItemId === itemId })}
                  onClick={() => handleClick(itemId, true)}
                  button
                  disableGutters
                >
                  <ListItemText
                    primary={isFunction(formatter) ? formatter(label) : label}
                    className="dropdown-item-text"
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Popover>
      </>}
  </span>)
}

AggregationTableDropdown.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  parentLevelOptions: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  dropdownTableTitle: PropTypes.string.isRequired,
  onItemClick: PropTypes.func.isRequired,
  selectedItemId: PropTypes.string.isRequired,
}
